import { createSlice } from "@reduxjs/toolkit";

interface InstitutionalBusinessState {
  company: string | null;
  regNumber: string | null;
  legalStructure: string | null;
  legalStructureOthers: string | null;
  countryOfIncorp: string | null;
  countryOfDomicile: string | null;
  website: string | null;
  address: string | null;
  postal: string | null;
  phoneNumber: string | null;
  industryGroup: string | null;
  industryDropdownValues: any | null;
  industry: string | null;
  industryOthers: string | null;
  investmentAmount: number | null;
  investorDeclarationQualified: boolean | null;
  incorporationDate: string | null;
}

const bizSlice = createSlice({
  name: "insitutionalBiz",
  initialState: {
    company: null,
    regNumber: null,
    legalStructure: null,
    legalStructureOthers: null,
    countryOfIncorp: null,
    countryOfDomicile: null,
    website: null,
    address: null,
    phoneNumber: null,
    postal: null,
    industryGroup: null,
    industryDropdownValues: null,
    industry: null,
    industryOthers: null,
    investmentAmount: null,
    investorDeclarationQualified: null,
    incorporationDate: null,
  } as InstitutionalBusinessState,
  reducers: {
    setCompanyRedux: (state, { payload: { company } }) => {
      state.company = company;
    },
    setRegNumberRedux: (state, { payload: { regNumber } }) => {
      state.regNumber = regNumber;
    },
    setLegalStructureRedux: (state, { payload: { legalStructure } }) => {
      state.legalStructure = legalStructure;
    },
    setLegalStructureOthersRedux: (
      state,
      { payload: { legalStructureOthers } }
    ) => {
      state.legalStructureOthers = legalStructureOthers;
    },
    setCountryOfIncorpRedux: (state, { payload: { countryOfIncorp } }) => {
      state.countryOfIncorp = countryOfIncorp;
    },
    setCountryOfDomicileRedux: (state, { payload: { countryOfDomicile } }) => {
      state.countryOfDomicile = countryOfDomicile;
    },
    setAddressRedux: (state, { payload: { address } }) => {
      state.address = address;
    },
    setPhoneNumberRedux: (state, { payload: { phoneNumber } }) => {
      state.phoneNumber = phoneNumber;
    },
    setPostalCodeRedux: (state, { payload: { postal } }) => {
      state.postal = postal;
    },
    setWebsiteRedux: (state, { payload: { website } }) => {
      state.website = website;
    },
    setIndustryGroupRedux: (state, { payload: { industryGroup } }) => {
      state.industryGroup = industryGroup;
    },
    setIndustryRedux: (state, { payload: { industry } }) => {
      state.industry = industry;
    },
    setIndustryDropdownValuesRedux: (state, { payload: { industryDropdownValues } }) => {
      state.industryDropdownValues = industryDropdownValues;
    },
    setIndustryOthersRedux: (state, { payload: { industryOthers } }) => {
      state.industryOthers = industryOthers;
    },
    setInvestmentAmountRedux: (state, { payload: { investmentAmount } }) => {
      state.investmentAmount = investmentAmount;
    },
    setInvestorDeclarationQualifiedRedux: (
      state,
      { payload: { investorDeclarationQualified } }
    ) => {
      state.investorDeclarationQualified = investorDeclarationQualified;
    },
    setIncorporationDateRedux: (state, { payload: { incorporationDate } }) => {
      state.incorporationDate = incorporationDate;
    },
  },
});

export const {
  setCompanyRedux,
  setRegNumberRedux,
  setLegalStructureRedux,
  setCountryOfIncorpRedux,
  setAddressRedux,
  setPhoneNumberRedux,
  setPostalCodeRedux,
  setCountryOfDomicileRedux,
  setWebsiteRedux,
  setLegalStructureOthersRedux,
  setIndustryGroupRedux,
  setIndustryDropdownValuesRedux,
  setIndustryRedux,
  setIndustryOthersRedux,
  setInvestmentAmountRedux,
  setInvestorDeclarationQualifiedRedux,
  setIncorporationDateRedux,
} = bizSlice.actions;

export default bizSlice.reducer;
